import React from 'react';
import { Col, Row, Spin } from 'antd';

import BasePageCard from 'components/wrappers/BasePageCard';
import BaseSectionMessage from 'components/wrappers/BaseSectionMessage';

import styles from './SupersetAnalyticsBlock.module.less';
import { useSupersetAnalyticsEmbed } from './useSupersetAnalyticsEmbed';

export default function SupersetAnalyticsBlock() {
  const { mountRef, forbidden, isCheckingAccess, isLoading, errorMessage } =
    useSupersetAnalyticsEmbed();

  if (forbidden || isCheckingAccess) {
    return null;
  }

  return (
    <Row gutter={[10, 10]}>
      <Col xs={24} className="d-flex">
        <BasePageCard
          className="full-header stretch-card"
          title="Reports"
          icons={<span className="icon icon-analytics" />}
        >
          {errorMessage ? (
            <BaseSectionMessage type="error" message={errorMessage} />
          ) : (
            <div className={styles.embedContainer}>
              {isLoading && (
                <div className={styles.loadingOverlay}>
                  <Spin size="large" />
                </div>
              )}
              <div
                ref={mountRef}
                className={styles.mountWrapper}
                data-testid="superset-dashboard-mount"
              />
            </div>
          )}
        </BasePageCard>
      </Col>
    </Row>
  );
}
